function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.75 39C9.75 22.846 22.846 9.75 39 9.75S68.25 22.846 68.25 39 55.154 68.25 39 68.25 9.75 55.154 9.75 39z",
  stroke: "#36443A",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 39l9.75 9.75L52 32.5",
  stroke: "#36443A",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3OCIgaGVpZ2h0PSI3OCIgdmlld0JveD0iMCAwIDc4IDc4IiBmaWxsPSJub25lIj4KPHBhdGggZD0iTTkuNzUgMzlDOS43NSAyMi44NDU3IDIyLjg0NTcgOS43NSAzOSA5Ljc1QzU1LjE1NDUgOS43NSA2OC4yNSAyMi44NDU3IDY4LjI1IDM5QzY4LjI1IDU1LjE1NDUgNTUuMTU0NSA2OC4yNSAzOSA2OC4yNUMyMi44NDU3IDY4LjI1IDkuNzUgNTUuMTU0NSA5Ljc1IDM5WiIgc3Ryb2tlPSIjMzY0NDNBIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjYgMzlMMzUuNzUgNDguNzVMNTIgMzIuNSIgc3Ryb2tlPSIjMzY0NDNBIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgTick as ReactComponent };